import {useRef} from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import { useSetState } from 'ahooks'
import CategoryModal from './components/CategoryModal';
import { config } from './config/index.tsx'
import styles from './index.module.less'
import {
  getGoodsCategoryTreeList,
  goodsCategoryDelete,
  goodsCategoryUpdateState
} from "@/services/goods.ts";
import {message, Switch} from "antd";

export default function PriceManage ()  {
  const [state, setState] = useSetState<any>({
    open: false,
    record: {},
    cateTreeList: []
  })

  const listRef = useRef()

  //   右侧数据查询
  const fetchList = () => {
    return new Promise((resolve, reject) => {
      getGoodsCategoryTreeList({}).then(res=>{
        resolve({records: res})
        setState({cateTreeList: res})
      }).catch(reject)
    })
  }

  // 右侧表格事件：
  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    console.log(record,11111);
    
    setState({open: true, record})
  }

  const onChangeStatus = (enabled: boolean, id: string)=>{
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${enabled ? '启用' : '禁用'}该数据`,
      onOk: () => {
       return goodsCategoryUpdateState({idList: [id], enabled}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const handleCloseCategoryModal = () => {
    setState({open: false, record: {}})
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
       return goodsCategoryDelete(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checkedChildren="启用" unCheckedChildren="禁用"
                       disabled={v && record.object?.initFlag}
                       checked={v} onClick={(checked) => onChangeStatus(checked, record.object.id)}/>
      },
      actionRender(_, record: Record<string, any>) {
        const level  = record.object?.cateIdPath?.split('>').length;
        
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record.object)}> 编辑 </SActionBtn>
            { level - 1 < 4 && !record.object.initFlag && <SActionBtn onClick={() => onEdit({parentId: record.id})}> 添加下级 </SActionBtn>}
            {!record.object.initFlag && <SActionBtn danger onClick={() => onDel(record.id)}> 删除 </SActionBtn>}
          </STableActions>
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      <SBack title="品类管理"></SBack>
      <div className={styles.rightTable}>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} tableType={'antd'} />
      </div>
      <CategoryModal fn={listRef.current?.reload} {...state} onClose={handleCloseCategoryModal} />
    </div>
  )
}